var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3962 28.4571C40.466 28.6328 40.5005 28.8184 40.5 29.0038V38.0025C40.5 38.8312 39.8125 39.5029 38.9644 39.5029C38.1163 39.5029 37.4288 38.8312 37.4288 38.0025V32.4686L32.9254 36.6026C29.1981 40.2462 23.8183 41.7667 18.6757 40.6298C13.5332 39.4929 9.34727 35.8577 7.58838 31.0012C7.30547 30.2201 7.72424 29.3627 8.52373 29.0863C9.32323 28.8099 10.2007 29.2191 10.4836 30.0002C11.8907 33.8854 15.2395 36.7936 19.3535 37.7031C23.4675 38.6126 27.7714 37.3962 30.7878 34.4486L35.0878 30.5007H29.7509C28.9029 30.5007 28.2154 29.829 28.2154 29.0004C28.2154 28.1717 28.9029 27.5 29.7509 27.5H38.9644C39.6091 27.5 40.1609 27.8881 40.3886 28.4383L40.3962 28.4571Z",
    fill: "#747D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09904 20.5429C6.03247 20.3672 5.99956 20.1816 6 19.9962V10.9975C6 10.1688 6.65626 9.4971 7.46578 9.4971C8.27531 9.4971 8.93156 10.1688 8.93156 10.9975V16.5314L13.2303 12.3974C16.7881 8.75377 21.9235 7.23332 26.8322 8.37019C31.741 9.50707 35.7367 13.1423 37.4156 17.9988C37.6857 18.7799 37.286 19.6373 36.5228 19.9137C35.7596 20.1901 34.9221 19.7809 34.652 18.9998C33.3089 15.1146 30.1123 12.2064 26.1853 11.2969C22.2583 10.3874 18.15 11.6038 15.2707 14.5514L11.1662 18.4993H16.2605C17.07 18.4993 17.7262 19.171 17.7262 19.9996C17.7262 20.8283 17.07 21.5 16.2605 21.5H7.46578C6.85044 21.5 6.32366 21.1119 6.10634 20.5617L6.09904 20.5429Z",
    fill: "#747D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.36a28759c162e67ac91a66e57be9d119.svg";
export { ForwardRef as ReactComponent };